export interface TestimonialCardProps {
  name: string
  location: string
  acreage: number
  goal: string
  quote: string
  imageSrc: string
}

const TestimonialCard = ({
  name,
  location,
  acreage,
  goal,
  quote,
  imageSrc,
}: TestimonialCardProps) => (
  <div
    className="w-84 lg:w-[502px] h-full bg-white rounded-md border border-dusk-50 p-6"
    data-testid={`testimonial-card-${name
      .toLocaleLowerCase()
      .replace(/\s+/g, "-")}`}
  >
    <div className="h-full flex flex-col gap-6">
      <div className="flex gap-4">
        <div className="w-26 shrink-0">
          <img
            className="w-full h-auto"
            src={imageSrc}
            data-testid="testimonial-card-img"
          />
        </div>

        <div className="w-full lg:w-96 lg:h-24 justify-start">
          <p
            className="text-green-700 text-base font-bold leading-[130%] tracking-[0.32px]"
            data-testid="testimonial-card-name"
          >
            {name}
          </p>

          <p
            className="text-charcoal-500 text-base font-normal leading-[140%] tracking-[0.32px]"
            data-testid="testimonial-card-location"
          >
            {`Landowner in ${location}`}
          </p>

          <p
            className="text-charcoal-500 text-base font-normal leading-[140%] tracking-[0.32px]"
            data-testid="testimonial-card-acreage"
          >
            {`${acreage} acres enrolled`}
          </p>

          <p
            className="text-charcoal-500 text-base font-normal leading-[140%] tracking-[0.32px]"
            data-testid="testimonial-card-goal"
          >
            {goal}
          </p>
        </div>
      </div>

      <div
        className="grow w-full text-charcoal-500 text-base font-normal leading-[140%] tracking-[0.32px] rounded-lg bg-cloud-300 p-6"
        data-testid="testimonial-card-quote"
      >
        “{quote}”
      </div>
    </div>
  </div>
)

export default TestimonialCard
